module.exports = __webpack_public_path__ + "static/woman_set_4teen.56b9d72e.svg";